import { LoadingSpinner } from "cprime-foundational-components";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import React, {
  useEffect,
  useState,
  Suspense,
  useMemo,
  useCallback,
} from "react";
import {
  fetchApplicationById,
  setAppId,
} from "../../store/slices/applicationDetailsSlice";
import { useParams, useNavigate } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import * as style from "./ApplicationList.module.scss";
import CreateEditRolesDetails from "../../Components/CreateEditRolesDetails/CreateEditRolesDetails";
import CreateEditRoleFeature from "../../Components/CreateEditRoleFeature/CreateEditRoleFeature";
import CreateEditRoleAPI from "../../Components/CreateEditRoleAPI/CreateEditRoleAPI";
import CreateEditRoleDataDomain from "../../Components/CreateEditRoleDataDomain/CreateEditRoleDataDomain";
import CreateEditRoleApprovedUsers from "../../Components/CreateEditRoleApprovedUsers/CreateEditRoleApprovedUsers";
import {
  selectCreateRole,
  createRole,
  setCurrentRoleId,
  selectCurrentRoleId,
  editRole,
  selectNamesData,
  verifyRole,
  updateNamesData,
  selectActivateButtonDisable,
  setActivateButtonDisable,
} from "../../store/slices/CreateRoleSlice";
import { triggerToast } from "../../utils/toast";
import CreateEditRoleSidePanel from "../../Components/CreateEditRoleAPI/CreateEditRoleAPISidePanel";
import {
  createDataRestriction,
  getRoleDetailsByRoleId,
  getRoleSetupDataRestrictionDropdownData,
} from "../../services/RequestAccess/RequestAccess";
import Button from "../../Components/Common/CprimeButton";
const RoleSetupPanleComponent = React.lazy(
  () =>
    import("../../Components/CreateEditRoleCommonFolder/RoleSetupPanelComponent"),
);
const CreateEditRoleDataDomainPanelBody = React.lazy(
  () =>
    import("../../Components/CreateEditRoleDataDomain/CreateEditRoleDataDomainPanelBody"),
);
import CreateEditRoleFeatureSidePanel from "../../Components/CreateEditRoleFeature/CreateEditRoleFeatureSidePanel";
import RoleActivateDeactivateDialog from "../../Components/Modals/RoleActivateDeactivateDialog";
import CustomBreadcrumb from "../../Components/CustomBreadcrumb/CustomBreadcrumb";
import { base64PrivateKey, getEnv } from "../../Constants/env";
import axios from "axios";
import { useIdToken } from "../../hooks/useAuthSession";
import { decodePolicyData } from "../../utils/commonUtil";

const CreateEditRoles = () => {
  const scssClass = style as any;
  const { id, action, roleId } = useParams();
  const { data } = useSelector((state: RootState) => state?.applicationDetails);
  const [selectedTab, setSelectedTab] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [domainOptionList, setDomainOptionList] = useState<Array<any>>([]);
  const [selectedDomainOptions, setDelectedDomainOptions] = useState<{
    id: string | number;
    label: string;
    allowed: Array<any>;
    restriction: Array<any>;
  }>({ id: "", label: "", allowed: [], restriction: [] });
  const [refresh, setRefresh] = useState<number>(0);
  const [cloneError, setCloneError] = useState<[]>([]);

  const dispatch: AppDispatch = useDispatch();
  const { data: createRolePayload } = useSelector(selectCreateRole);
  const navigate = useNavigate();
  const [commonButtonTitle, setCommonButtonTitle] = useState("Edit");
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [roleDetailsEdit, setRoleDetailsEdit] = useState(false);
  const [roleConditionsEdit, setRoleConditionsEdit] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [activateButtonData, setActivateButtonData] = useState<any>(null);
  const currentRoleId = useSelector(selectCurrentRoleId);
  const namesData = useSelector(selectNamesData);

  const cloneRoleData = useSelector(
    (state: RootState) => state?.createRole?.cloneRoleData,
  );
  const [saveButtonLabel, setSaveButtonLabel] = useState("");

  const activateButtonDisable = useSelector(selectActivateButtonDisable);
  const isRoleActive =
    String(namesData?.status || saveButtonLabel || "").toLowerCase() ===
    "active";
  const role_id = roleId?.split("-")?.[1];
  // const envtype = getEnv()?.envtype;
  // const isEditable = useMemo(
  //   () => envtype !== "prod" && envtype !== "qa",
  //   [envtype],
  // );
  const isEditable = true; // As per new requirement, all environments are editable but changes in prod and qa should be made in lower env and promoted. So showing warning message for prod and qa env in UI.
  const idToken = useIdToken();
  const [isAccessible, setIsAccessible] = useState(false);

  const checkIsAccessible = useCallback(async () => {
    if (!idToken) return false;
    try {
      const { data, status } = await axios.get("/v1/roleconsumption/policy", {
        baseURL: getEnv()?.baseURL,
        headers: {
          Authorization: idToken,
        },
      });
      if (status !== 200) return false;

      const decodeData = decodePolicyData(data?.data, base64PrivateKey);
      const accessList = Array.isArray(decodeData)
        ? decodeData.flatMap((item: any) => item?.Access ?? [])
        : (decodeData?.Access ?? []);

      return accessList.some((access: any) =>
        (access?.feature ?? []).some(
          (feature: any) =>
            feature?.FeatureName === "App Management" &&
            feature?.FeaturePermission?.some(
              (permission: any) => permission?.Permission === "Edit",
            ),
        ),
      );
    } catch (error) {
      // console.error("Error checking access:", error);
      return false;
    }
  }, [idToken]);

  useEffect(() => {
    let isMounted = true;

    const loadAccess = async () => {
      const hasAccess = await checkIsAccessible();
      if (isMounted) {
        setIsAccessible(hasAccess);
      }
    };

    loadAccess();

    return () => {
      isMounted = false;
    };
  }, [checkIsAccessible]);

  const createFeaturePayload = useSelector(
    (state: RootState) =>
      state?.createRole?.featureRelations?.createEditPayload,
  );

  const editPayload = useSelector(
    (state: RootState) => state.createRole.editApiRelationsPayload,
  );

  const [featureRelationsSubmitBtn, setfeatureRelationsSubmitBtn] =
    useState(true);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (currentRoleId || cloneRoleData.sourceRoleId) {
      setSelectedTab(newValue);
    } else {
      triggerToast("Pleaes Save the role detials to proceed further", "error");
    }
  };

  const fetchRoleName = async () => {
    if (!role_id) return;
    const roleResponse = await getRoleDetailsByRoleId(role_id);
    setRoleName(roleResponse?.data?.roleName);
    setSaveButtonLabel(roleResponse?.data?.status);
  };

  const handleClose = () => {
    setOpenPanel(false);
  };

  const getDataRestrictionDropdownData = async () => {
    try {
      const res = await getRoleSetupDataRestrictionDropdownData(
        id?.split("-")[1],
      );
      setDomainOptionList(res?.data);
    } catch (err) {}
  };
  useEffect(() => {
    getDataRestrictionDropdownData();
  }, [data]);

  useEffect(() => {
    fetchRoleName();
    if (selectedTab === 1) {
      setCommonButtonTitle("Map Feature");
    } else if (selectedTab === 2) {
      setCommonButtonTitle("Map API");
    } else if (selectedTab === 3) {
      setCommonButtonTitle("Create Restriction");
    } else if (selectedTab === 4) {
      setCommonButtonTitle("");
    }
  }, [selectedTab]);

  useEffect(() => {
    if (id) {
      const applicationId = id?.split("-")?.[1];
      if (applicationId) {
        dispatch(fetchApplicationById(Number(applicationId)) as any);
        dispatch(setAppId(Number(applicationId)));
      }
    }
    setActivateButtonData({
      role_id: currentRoleId,
      status: namesData?.status,
    });
    verifyRoleDetails();
  }, []);

  useEffect(() => {
    const hasIncompleteEnvCondition =
      createFeaturePayload?.associatedGroup &&
      !Array.isArray(createFeaturePayload.associatedGroup) &&
      Object.values(createFeaturePayload.associatedGroup).some(
        (values: any) => Array.isArray(values) && values.length === 0,
      );
    if (
      createFeaturePayload?.featureId !== null &&
      createFeaturePayload?.permissionIds?.length > 0 &&
      !hasIncompleteEnvCondition
    ) {
      setfeatureRelationsSubmitBtn(
        createFeaturePayload?.permissionIds?.some(
          (permission: { permissionName: string }) =>
            permission?.permissionName === "view",
        )
          ? false
          : true,
      );
    } else {
      setfeatureRelationsSubmitBtn(true);
    }
  }, [createFeaturePayload]);

  const handleSaveAsDraft = async () => {
    if (!createRolePayload) {
      // console.error("No payload found in createRole state");
      return;
    }

    try {
      const sanitizedRoleConditions =
        createRolePayload?.roleConditions?.map(
          ({
            id,
            createdBy,
            createdDateTime,
            ...rest
          }: {
            id: any;
            createdBy?: any;
            createdDateTime?: any;
            [key: string]: any;
          }) => rest,
        ) || [];
      if (cloneRoleData?.isClone) {
        const clonePayload = {
          appId: createRolePayload?.appId,
          roleName: createRolePayload?.roleName,
          objectId: createRolePayload?.objectId,
          sailpointRoleName: createRolePayload?.sailpointRoleName,
          description: createRolePayload?.description,
          status: "draft",
          isAutoApprove: createRolePayload?.isAutoApprove,
          roleConditions: sanitizedRoleConditions,
          context: createRolePayload?.context || [],
          isClone: true,
          is_active: false,
          sourceRoleId: cloneRoleData?.sourceRoleId,
        };

        try {
          const result = await dispatch(createRole(clonePayload)).unwrap();
          const newId = result?.roleId || result?.roleid;
          if (result?.roleId) {
            dispatch(setCurrentRoleId(newId));
            setActivateButtonData({
              role_id: newId,
              status: "draft",
            });

            dispatch(
              updateNamesData({
                ...clonePayload,
                roleName: clonePayload.roleName,
                isAutoApprove: clonePayload.isAutoApprove,
                objectId: clonePayload.objectId,
                sailpointRoleName: clonePayload.sailpointRoleName,
                roleConditions: sanitizedRoleConditions,
                description: clonePayload.description,
              }),
            );
            setCloneError([]);
            if (cloneRoleData.sourceRoleId) {
              verifyRoleDetailsFeatures();
            }

            triggerToast(
              "Role cloned successfully, Enter other details",
              "success",
            );

            return;
          }

          if (result?.status === "FAILURE") {
            setCloneError(result?.message);
            return;
          }
        } catch (error: any) {
          // HTTP / network / server error
          triggerToast("Failed to clone role", "error");
        }
      } else if (role_id) {
        const editPayload: any = {
          appId: createRolePayload?.appId,
          // dealerName: createRolePayload?.dealerName,
          description: createRolePayload?.description,
          // distribution: createRolePayload?.distribution,
          // fleet: createRolePayload?.fleet,
          // lifecycleStatus: createRolePayload?.lifecycleStatus,
          // plant: createRolePayload?.plant,
          // region: createRolePayload?.region,
          roleId: role_id,
          isAutoApprove: createRolePayload?.isAutoApprove,
          status: saveButtonLabel,
          roleName: createRolePayload?.roleName,
          sailpointRoleName: createRolePayload?.sailpointRoleName,
          objectId: createRolePayload?.objectId,
          roleConditions: sanitizedRoleConditions,
          context: createRolePayload?.context,
        };

        setCloneError([]);
        setActivateButtonData({
          role_id: editPayload?.roleId,
          status: editPayload?.status,
        });
        await dispatch(editRole(editPayload))?.unwrap();
        dispatch(
          updateNamesData({
            roleName: createRolePayload?.roleName,
            isAutoApprove: createRolePayload?.isAutoApprove,
            objectId: createRolePayload?.objectId,
            sailpointRoleName: createRolePayload?.sailpointRoleName,
            roleConditions: sanitizedRoleConditions,
            description: createRolePayload?.description,
            status: saveButtonLabel,
          }),
        );
        triggerToast("Role updated successfully", "success");
      } else {
        const result = await dispatch(createRole(createRolePayload))?.unwrap();
        if (result?.roleId || result?.roleid) {
          const newId = result?.roleId || result?.roleid;
          dispatch(setCurrentRoleId(newId));
          setActivateButtonData({
            role_id: newId,
            status: "draft",
          });
          dispatch(
            updateNamesData({
              roleName: createRolePayload?.roleName,
              isAutoApprove: createRolePayload?.isAutoApprove,
              objectId: createRolePayload?.objectId,
              sailpointRoleName: createRolePayload?.sailpointRoleName,
              roleConditions: sanitizedRoleConditions,
              description: createRolePayload?.description,
            }),
          );
          triggerToast(
            "Role created successfully, Enter other details",
            "success",
          );
        } else {
          triggerToast(result?.error || "Unkown Error", "error");
        }
      }
    } catch (error: any) {
      triggerToast("Failed to create role", "error");
    } finally {
      setRoleDetailsEdit(false);
      setRoleConditionsEdit(false);
    }
  };

  const isCreateRolePayloadValid = () => {
    if (!isEditable) return false;
    if (!createRolePayload || typeof createRolePayload !== "object")
      return false;

    const isAzureAD = data?.protected_by_name === "AzureAD";

    return Object.entries(createRolePayload)?.every(([key, value]) => {
      // objectId is not required when the app is protected by AzureAD
      if (isAzureAD && key === "objectId") return true;

      return (
        value !== null &&
        value !== undefined &&
        (typeof value !== "string" || value?.trim() !== "")
      );
    });
  };

  const verifyRoleDetails = async () => {
    try {
      if (!currentRoleId) {
        // throw new Error("Missing role_id to verify.");
        return;
      }
      const result = await dispatch(verifyRole(currentRoleId))?.unwrap();
      if (result && result[0]?.features && namesData?.status === "draft") {
        dispatch(setActivateButtonDisable(false));
      } else {
        dispatch(setActivateButtonDisable(true));
      }
    } catch (error) {
      throw error;
    }
  };

  const verifyRoleDetailsFeatures = async () => {
    try {
      if (!cloneRoleData.sourceRoleId) {
        throw new Error("Missing role_id to verify.");
      }
      const result = await dispatch(
        verifyRole(cloneRoleData.sourceRoleId),
      )?.unwrap();
      if (result && result?.[0]?.features) {
        dispatch(setActivateButtonDisable(false));
      } else {
        dispatch(setActivateButtonDisable(true));
      }
    } catch (error) {
      throw error;
    }
  };

  const checkIsDisable = () => {
    if (
      editPayload?.apiName &&
      editPayload?.endpointPath &&
      editPayload?.description &&
      editPayload?.methodType &&
      editPayload?.access
    ) {
      return false;
    }
    return true;
  };

  return (
    <div
      style={{
        margin: "2rem 2rem 0 2rem",
        maxHeight: "calc(100vh - 210px)",
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <CustomBreadcrumb
          items={[
            {
              label: "Application List",
              href: "/application-list",
              icon: <HomeOutlinedIcon sx={{ color: "#2469FF" }} />,
            },
            {
              label: `${data?.app_cmdb_name}`,
              href: `/application-list/app-${data?.id}`,
            },
            {
              label: `${action === "create-role" ? "Create Role" : "Edit Role"}`,
              href: undefined,
            },
          ]}
        />

        <div
          className={scssClass?.appDetailContainer}
          style={{ marginTop: "1rem" }}
        >
          <div className={scssClass?.header}>
            <span className={scssClass?.title}>
              {action === "create-role" ? "Create Role" : `${roleName}`}
            </span>
            {commonButtonTitle !== "Edit" && (
              <Button
                variant="secondary"
                size="medium"
                onClick={() => {
                  if (
                    selectedTab === 1 ||
                    selectedTab === 2 ||
                    selectedTab === 3
                  ) {
                    setOpenPanel(true);
                  }
                }}
                disabled={!isEditable || !isAccessible}
                sx={{
                  visibility: `${selectedTab === 0 || selectedTab === 4 ? `hidden` : `visible`}`,
                }}
              >
                {commonButtonTitle}
              </Button>
            )}
          </div>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="standard"
            aria-label="application tabs"
            sx={{
              //position: "sticky",
              top: "5rem",
              backgroundColor: "white",
              width: "100%",
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
                padding: "1rem 2rem",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
              "& .Mui-disabled": {
                opacity: 0.5,
              },
            }}
          >
            <Tab
              label="Details"
              sx={{
                textTransform: "none",
                textWrap: "nowrap",
                fontWeight: selectedTab === 0 ? "bold" : "",
                width: "max-content",
              }}
            />
            <Tab
              label="Features"
              sx={{
                textTransform: "none",
                textWrap: "nowrap",
                fontWeight: selectedTab === 1 ? "bold" : "",
                width: "max-content",
              }}
              disabled={currentRoleId === null}
            />
            <Tab
              label="APIs"
              sx={{
                textTransform: "none",
                textWrap: "nowrap",
                fontWeight: selectedTab === 2 ? "bold" : "",
                width: "max-content",
              }}
              disabled={currentRoleId === null}
            />
            <Tab
              label="Data Restrictions"
              sx={{
                textTransform: "none",
                textWrap: "nowrap",
                fontWeight: selectedTab === 3 ? "bold" : "",
                width: "max-content",
              }}
              disabled={currentRoleId === null}
            />
            <Tab
              label="Approved Users"
              sx={{
                textTransform: "none",
                textWrap: "nowrap",
                fontWeight: selectedTab === 4 ? "bold" : "",
                width: "max-content",
              }}
              disabled={currentRoleId === null}
            />
          </Tabs>

          <div className={scssClass?.createRoleContainer}>
            {selectedTab === 0 && (
              <CreateEditRolesDetails
                error={cloneError}
                isEditable={isEditable || isAccessible}
                protected_by_name={data?.protected_by_name}
                roleDetailsEdit={roleDetailsEdit}
                setRoleDetailsEdit={setRoleDetailsEdit}
                roleConditionsEdit={roleConditionsEdit}
                setRoleConditionsEdit={setRoleConditionsEdit}
              />
            )}
            {selectedTab === 1 && (
              <CreateEditRoleFeature isEditable={isEditable || isAccessible} />
            )}
            {selectedTab === 2 && (
              <CreateEditRoleAPI isEditable={isEditable || isAccessible} />
            )}
            {selectedTab === 3 && (
              <CreateEditRoleDataDomain
                refresh={refresh}
                isEditable={isEditable || isAccessible}
              />
            )}
            {selectedTab === 4 && (
              <CreateEditRoleApprovedUsers
                appId={data?.id}
                roleId={Number(role_id)}
                roleName={roleName}
              />
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          position: "fixed",
          width: "calc(100% - 4rem)",
          padding: "10px 0",
          bottom: 0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button
          variant="tertiary"
          sx={{ margin: "0 10px" }}
          size="medium"
          onClick={() =>
            navigate(`/application-list/app-${data?.id}`, {
              state: { selectedTab: 3 },
            })
          }
        >
          Cancel
        </Button>
        <Button
          variant="tertiary"
          sx={{ margin: "0 10px" }}
          size="medium"
          onClick={handleSaveAsDraft}
          disabled={!isAccessible || !isCreateRolePayloadValid()}
        >
          {saveButtonLabel === "active" ? "Save" : "Save As Draft"}
        </Button>
        <Button
          variant="primary"
          sx={{ margin: "0 10px" }}
          size="medium"
          onClick={() => setDialogOpen(true)}
          disabled={!isAccessible || isRoleActive || activateButtonDisable}
        >
          Activate Role
        </Button>
      </div>
      {openPanel && selectedTab === 2 && (
        <Suspense fallback={<LoadingSpinner fullScreen={true} />}>
          <RoleSetupPanleComponent
            open={openPanel}
            title="Create API Mapping"
            isEdit={false}
            isSubmitDisable={checkIsDisable()}
            onClose={handleClose}
            BodyComponent={
              <CreateEditRoleSidePanel
                tableData={[]}
                isEdit={false}
                clickedRowId={null}
              />
            }
            tabValue={selectedTab}
          />
        </Suspense>
      )}
      {openPanel && selectedTab === 3 && (
        <Suspense fallback={<LoadingSpinner fullScreen={true} />}>
          <RoleSetupPanleComponent
            open={openPanel}
            title="Add Domain Restrictions"
            isEdit={false}
            onClose={handleClose}
            BodyComponent={
              <Suspense fallback={<LoadingSpinner fullScreen={true} />}>
                <CreateEditRoleDataDomainPanelBody
                  domainOptionList={domainOptionList}
                  handleChange={(data) => setDelectedDomainOptions(data)}
                />
              </Suspense>
            }
            tabValue={selectedTab}
            submitLabel={"Save Domain"}
            isSubmitDisable={selectedDomainOptions?.id === ""}
            onSubmit={async () => {
              const response = await createDataRestriction({
                roleId: currentRoleId,
                domainId: selectedDomainOptions?.id,
                allowedSubDomainName:
                  selectedDomainOptions?.allowed?.length > 0
                    ? selectedDomainOptions?.allowed?.map((d) => d?.id)
                    : [],
                deniedSubDomainName:
                  selectedDomainOptions?.restriction?.length > 0
                    ? selectedDomainOptions?.restriction?.map((d) => d?.id)
                    : [],
              });
              triggerToast(
                `${response?.message}`,
                response?.status?.toLowerCase(),
              );
              setRefresh((prev) => prev + 1);
              handleClose();
            }}
          />
        </Suspense>
      )}
      {openPanel && selectedTab === 1 && (
        <Suspense fallback={<LoadingSpinner fullScreen={true} />}>
          <RoleSetupPanleComponent
            open={openPanel}
            title="Create Feature Mapping"
            isEdit={false}
            onClose={handleClose}
            BodyComponent={
              <Suspense fallback={<LoadingSpinner fullScreen={true} />}>
                <CreateEditRoleFeatureSidePanel isEdit={false} />
              </Suspense>
            }
            tabValue={selectedTab}
            isSubmitDisable={featureRelationsSubmitBtn}
          />
        </Suspense>
      )}

      {dialogOpen && (
        <RoleActivateDeactivateDialog
          open={dialogOpen}
          onClose={() => {
            fetchRoleName();
            setDialogOpen(false);
          }}
          data={activateButtonData}
        />
      )}
    </div>
  );
};

export default CreateEditRoles;
